export enum TicketTemplateComponentTypeEnum {
    BARCODE_C128 = 'BARCODE_C128',
    TICKET_COMPONENT_HORIZONTAL = 'TICKET_COMPONENT_HORIZONTAL',
    IMAGE_GENERAL = 'IMAGE_GENERAL',
    IMAGE_CM_LOGO = 'IMAGE_CM_LOGO',
    BARCODE_QR = 'BARCODE_QR',
    DYNAMIC_TEXT_COMPONENT = 'DYNAMIC_TEXT_COMPONENT'
}

